/** One `?name=value` parameter from the workspace hash route; null when absent or empty. */
export function hashParam(name: string): string | null {
  const query = typeof location === 'undefined' ? '' : (location.hash.split('?')[1] ?? '');
  return new URLSearchParams(query).get(name) || null;
}
